import React from 'react';
import { useUrlDataContext } from '../lib/UrlDataContext';
import { NewProduct } from './actions/NewProduct';
import { MatchToProduct } from './actions/MatchToProduct';
import { EditProduct } from './actions/EditProduct';
import { useActionContext } from '../lib/ActionContext';

export const MatchOrCreateProduct = () => {
  const { currentUrlData } = useUrlDataContext();

  const { view } = useActionContext();

  if (!currentUrlData) {
    return null;
  }

  switch (view) {
    case 'best-match':
    case 'search':
      return <MatchToProduct />;

    case 'new-product':
      return <NewProduct />;

    case 'edit-product':
      return <EditProduct />;

    default:
      return null;
  }
};
